var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 5.83334L8.1666 3.5M1.45825 12.5417L3.43247 12.3223C3.67367 12.2955 3.79427 12.2821 3.907 12.2456C4.007 12.2132 4.10218 12.1675 4.18994 12.1096C4.28885 12.0444 4.37465 11.9586 4.54626 11.787L12.2499 4.08334C12.8943 3.43901 12.8943 2.39434 12.2499 1.75C11.6056 1.10567 10.5609 1.10567 9.9166 1.75L2.21293 9.45366C2.04132 9.62527 1.95552 9.71107 1.89029 9.80999C1.83242 9.89774 1.78668 9.99292 1.7543 10.0929C1.71781 10.2057 1.70441 10.3263 1.67761 10.5675L1.45825 12.5417Z",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "clip0_2_1126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGrey);
export default __webpack_public_path__ + "static/media/edit-icon-grey.cf8353d9.svg";
export { ForwardRef as ReactComponent };